import Header from "../../components/Header"
import Footer from "../../components/Footer"
import "./page.css"
import SubtitleRule from "../../components/SubtitleRule";

export default function Contact() {
    return (
        <div className="relative w-screen overflow-hidden">
            <Header />
            <div className="w-full bg-black p-[50px] flex flex-col items-center">
                <SubtitleRule text="Telegram" />
                <h3 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 pt-[50px]">Message us on Telegram</h3>
                <a href="https://t.me/codewavesolutions" className='z-20 rounded-full bg-gradient-to-r from-sky-400 hover:from-white to-fuchsia-600 hover:to-white m-[50px]'>
                    <h2 className='px-8 py-2 w-full h-full text-white hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-sky-500 hover:to-fuchsia-600'>Click Here</h2>
                </a>
                <SubtitleRule text="Discord" />
                <h3 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 pt-[50px]">Message us on Discord</h3>
                <a href="https://discord.gg/MMhpR6G9jM" className='z-20 rounded-full bg-gradient-to-r from-sky-400 hover:from-white to-fuchsia-600 hover:to-white m-[50px]'>
                    <h2 className='px-8 py-2 w-full h-full text-white hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-sky-500 hover:to-fuchsia-600'>Click Here</h2>
                </a>
                <SubtitleRule />
            </div>
            <Footer />
        </div>
    );
}